export enum BoosComplexSelectType {
  NOW = 'NOW',
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  THIS_WEEK = 'THIS_WEEK',
  THIS_MONTH = 'THIS_MONTH',
  SPECIAL = 'SPECIAL',
  SPECIAL1 = 'SPECIAL'
}
